import { stats } from "@/mocks/verify";

const statStyles: Record<string, string> = {
  total: "text-primary-700",
  refuted: "text-foreground-800",
  confirmed: "text-accent-600",
  reversed: "text-primary-700",
};

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="mx-auto max-w-7xl px-4 pt-28 pb-12 md:px-6 md:pt-36 md:pb-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:items-center">
          {/* 左侧主文案 */}
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3.5 py-1.5 text-xs font-semibold text-accent-700">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
              </span>
              全程追踪 · 持续更新
            </span>

            <h2 className="mt-6 font-heading text-3xl leading-[1.3] font-bold text-foreground-950 md:text-[2.75rem] md:leading-[1.28]">
              传闻满天飞，
              <br />
              哪些是真、哪些是假？
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-[17px]">
              围绕网络热传的争议事件与“黑料”爆料，我们以证据链、反转时间线与当事人澄清为核心，逐条核实真伪，把来龙去脉整理清楚，
              陪你一起辨别，不再被断章取义带节奏。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#latest"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
              >
                进入求证榜单
                <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
              </a>
              <a
                href="#contact"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-search-eye-line text-base" aria-hidden="true"></i>
                提交一条待核传闻
              </a>
            </div>

            <p className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-shield-check-line text-sm text-primary-600" aria-hidden="true"></i>
              对事不对人，结论始终以可核验证据为准
            </p>
          </div>

          {/* 右侧今日求证卡 */}
          <div className="relative rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
            <div className="absolute -top-px right-8 h-1 w-16 rounded-b bg-accent-500" aria-hidden="true"></div>
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg font-bold text-foreground-950">今日求证快讯</h3>
              <span className="text-xs font-medium text-foreground-400">更新于 09-04</span>
            </div>

            <ul className="mt-5 flex flex-col divide-y divide-background-200">
              {[
                {
                  tag: "查无实据",
                  tagCls: "bg-secondary-100 text-secondary-900",
                  text: "“注胶虾大量流入市场”为旧闻翻炒，非全国性事件。",
                },
                {
                  tag: "部分属实",
                  tagCls: "bg-primary-100 text-primary-800",
                  text: "“睡前玩手机会损伤睡眠”方向成立，但“永久损伤”被夸大。",
                },
                {
                  tag: "发生反转",
                  tagCls: "bg-accent-100 text-accent-800",
                  text: "剧组停工爆料，经排期与差旅证据曝光后反转。",
                },
              ].map((it, i) => (
                <li key={i} className="flex items-start gap-3 py-3.5">
                  <span
                    className={`mt-0.5 shrink-0 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold ${it.tagCls}`}
                  >
                    {it.tag}
                  </span>
                  <p className="text-sm leading-relaxed text-foreground-700">{it.text}</p>
                </li>
              ))}
            </ul>

            <a
              href="#latest"
              className="mt-2 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              查看全部求证结果
              <i className="ri-arrow-right-s-line text-base" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        {/* 数据条 */}
        <dl className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-background-200 bg-background-200 md:mt-16 md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.key} className="flex flex-col bg-background-50 px-5 py-5 md:px-7 md:py-6">
              <dt className="order-2 mt-1 text-xs font-medium text-foreground-500 md:text-sm">
                {s.label}
              </dt>
              <dd
                className={`order-1 font-heading text-2xl font-bold tracking-tight md:text-[2rem] ${
                  statStyles[s.key] || "text-foreground-950"
                }`}
              >
                {s.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}